module.exports = __webpack_public_path__ + "assets/img/32_643.8723386b.jpg";